import React from "react";
import {
    TextValidator,
    ValidatorComponentProps,
} from "react-material-ui-form-validator";

interface ITextValidatorHcs extends ValidatorComponentProps {
    shrink?: boolean;
}

export const TextValidatorHcs = (params: ITextValidatorHcs) => {
    const {
        shrink,
        value,
        type,
        InputLabelProps,
        inputProps,
        InputProps,
        onWheel,
        ...rest
    } = params as any;

    const isNumber = type === "number";

    const preventWheel = (e: React.WheelEvent) => {
        if (isNumber) {
            e.preventDefault();
            e.stopPropagation();

            const target = e.target as HTMLElement;
            target.blur?.();
        }

        onWheel?.(e);
    };

    return (
        <TextValidator
            {...rest}
            type={isNumber ? "text" : type}
            value={value ?? ""}
            onWheelCapture={preventWheel}
            InputLabelProps={{
                ...InputLabelProps,
                shrink:
                    shrink ||
                    !!value ||
                    type === "date" ||
                    type === "file",
            }}
            inputProps={{
                ...inputProps,
                type: isNumber ? "text" : type,
                inputMode: isNumber ? "decimal" : inputProps?.inputMode,
                onWheel: preventWheel,
            }}
        />
    );
};